import { createStore } from 'redux';
import reducers from 'srcAlias/client/state/reducers';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

const createReduxStore = (initialState = {}) => {
  return createStore(reducers, initialState, composeWithDevTools());
};

export default createReduxStore;
